import React, { useState } from 'react';
import { FiX, FiClock, FiUser, FiImage } from 'react-icons/fi';
import { formatDateTime } from '../data/carsData';

const BookingImageGallery = ({ images, imageType, currentUserId, onDelete, canDelete = false }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  if (!images || images.length === 0) {
    return null;
  }

  const formatImageDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Asia/Kolkata'
      });
    } catch {
      return dateString;
    }
  };

  return (
    <>
      <div className="mb-4">
        <h4 className="text-sm font-semibold text-gray-700 mb-3">
          {imageType === 'before-ride' ? 'Before Ride Images' : 'After Ride Images'}
          <span className="ml-2 text-xs font-normal text-gray-500">({images.length}/15)</span>
        </h4>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {images.map((image) => (
            <div key={image.id} className="relative group">
              <div
                className="relative aspect-square bg-gray-100 rounded-lg overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary-500 transition-all"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.url}
                  alt={image.description || 'Car image'}
                  className="w-full h-full object-contain bg-gray-100"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                  <FiImage className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={24} />
                </div>
                {canDelete && image.uploadedBy === currentUserId && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm('Are you sure you want to delete this image?')) {
                        onDelete(image.id, imageType, image.path);
                      }
                    }}
                    className="absolute top-1 right-1 p-1 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600"
                  >
                    <FiX size={12} />
                  </button>
                )}
              </div>
              {image.description && (
                <p className="text-xs text-gray-600 mt-1 line-clamp-2">{image.description}</p>
              )}
              <div className="text-xs text-gray-500 mt-1">
                <div className="flex items-center gap-1">
                  <FiClock size={10} />
                  {formatImageDate(image.uploadedAt)}
                </div>
                {image.uploadedByName && (
                  <div className="flex items-center gap-1 mt-0.5">
                    <FiUser size={10} />
                    {image.uploadedByName}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh] bg-white rounded-lg overflow-hidden">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 p-2 bg-black bg-opacity-50 text-white rounded-full hover:bg-opacity-70 z-10"
            >
              <FiX size={20} />
            </button>
            <img
              src={selectedImage.url}
              alt={selectedImage.description || 'Car image'}
              className="max-w-full max-h-[90vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 text-white p-4">
              {selectedImage.description && (
                <p className="text-sm mb-2">{selectedImage.description}</p>
              )}
              <div className="flex items-center gap-4 text-xs text-gray-300">
                <div className="flex items-center gap-1">
                  <FiClock size={12} />
                  {formatImageDate(selectedImage.uploadedAt)}
                </div>
                {selectedImage.uploadedByName && (
                  <div className="flex items-center gap-1">
                    <FiUser size={12} />
                    {selectedImage.uploadedByName}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BookingImageGallery;
